var render = function render(){var _vm=this,_c=_vm._self._c;return (this.params.data && _vm.getCountryId())?_c('span',{class:`flag-icon flag-icon-${_vm.getCountryId()}`}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }